/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import cn from 'classnames';
import { memo, useState } from 'react';

import { CUSTOM_CHAINS } from 'shared/constants/custom-chain.constants';
import { RISK_OPTIONS, RISK_TYPE } from 'shared/constants/risks.constants';
import { isEmpty } from 'shared/helpers/common.helpers';
import { withTranslation } from 'shared/helpers/i18n.helpers';
import { Web3ContractEntity } from 'shared/interfaces/analyze.interfaces';
import { TraceWithRisk } from 'shared/interfaces/fetch.interfaces';

import AuditedContracts from './AuditedContracts';
import Detects from './Detects';
import MediumRisksInfo from './MediumRisksInfo';
import Share from './Share';
import { iconSrcByRisk } from './constants';
import styles from './styles.module.scss';
import { ProtocolRisks } from '../../Scan/ScanningResult/interfaces';
import { MessageData } from '../../Scan/interfaces';

interface Props {
  risk: RISK_TYPE;
  label?: string;
  risks: ProtocolRisks[]
  handleContractSelect?: (tokenAddress: string, type: Web3ContractEntity.type) => void;
  trace?: TraceWithRisk[];
  detects: MessageData[];
  chain?: CUSTOM_CHAINS;
  isLightMode?: boolean;
  textByRisk?: {
    [RISK_TYPE.LOW]: string
    [RISK_TYPE.MIDDLE]: string
    [RISK_TYPE.CRITICAL]: string
  }
}

const TEXT_BY_RISK = {
  [RISK_TYPE.LOW]: `${withTranslation('No critical risks found')}.`,
  [RISK_TYPE.MIDDLE]: `${withTranslation('We found moderated risks')}. ${withTranslation('Read how to verify')}.`,
  [RISK_TYPE.CRITICAL]: `${withTranslation('We found critical risks')}.`,
};

const Report = ({
  risk, risks, handleContractSelect, trace, detects, label, chain, isLightMode, textByRisk = TEXT_BY_RISK,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const onContractSelect = (
    data: ProtocolRisks,
  ) => handleContractSelect && handleContractSelect(data.contract?.address || '', data.contract?.type as Web3ContractEntity.type);

  const mappedDetects = risk === RISK_TYPE.LOW ? [] : detects.map((detect) => {
    const detectRisk = risks.find((riskItem) => detect.address && riskItem?.contract?.address === detect.address);
    if (detectRisk) {
      return ({
        onClick: () => onContractSelect(detectRisk),
        ...detect,
      });
    }
    return detect;
  });

  return (
    <div
      className={cn(styles.wrap, styles[risk.toLowerCase()], { [styles.open]: isOpen })}
    >
      <img className={styles.icon} src={iconSrcByRisk[risk]} alt="" />
      <div className={styles.top}>
        <div className={styles.header}>
          {/* {!isEmpty(itemsCount) && (
            <div className={styles.count}>
              {itemsCount} {withTranslation(pluralize('item', itemsCount || 0))} {withTranslation('analyzed')}
            </div>
          )} */}
        </div>
        <div className={cn(styles.risk, styles[risk])}>
          <span className={styles.riskText}>{RISK_OPTIONS[risk].title}</span>
          {!isEmpty(label) && <div>{label}</div>}
        </div>
      </div>
      <div className={styles.description}>
        {textByRisk[risk]}
      </div>
      <Detects data={mappedDetects} isLightMode={isLightMode} />
      {risk === RISK_TYPE.MIDDLE && <MediumRisksInfo />}
      {risk === RISK_TYPE.CRITICAL && <Share detects={mappedDetects} />}
      {!isLightMode && (Boolean(risks.length) || trace)
       && (
         <AuditedContracts
           trace={trace}
           isOpen={isOpen}
           risks={risks}
           handleContractSelect={onContractSelect}
           chain={chain}
           toggleOpen={() => setIsOpen(!isOpen)}
         />
       )}
      <div className={styles.gradient} />
    </div>
  );
};

export default memo(Report);
